import React, { FC } from 'react';
import { Tab as BaseTab } from '@material-ui/core';

interface TabProps {
  label: string;
  value: number;
}

const Tab: FC<TabProps> = ({ label, value, ...props }) => {
  return <BaseTab label={label} value={value} {...props} />;
};

export default Tab;
